import React, { createContext, useContext, useState } from 'react';

const OrderModalContext = createContext();

export const useOrderModal = () => {
  const context = useContext(OrderModalContext);
  if (!context) {
    throw new Error('useOrderModal must be used within an OrderModalProvider');
  }
  return context;
};

export const OrderModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preselectedLocation, setPreselectedLocation] = useState(null);
  const [orderType, setOrderType] = useState(null); // 'pickup', 'delivery', or null

  const openModal = (locationSlug = null, specificOrderType = null) => {
    setPreselectedLocation(locationSlug);
    setOrderType(specificOrderType); // Set the specific order type
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setPreselectedLocation(null);
    setOrderType(null); // Reset order type when closing
  };

  const value = {
    isOpen,
    preselectedLocation,
    orderType, // Add orderType to context value
    openModal,
    closeModal
  };

  return (
    <OrderModalContext.Provider value={value}>
      {children}
    </OrderModalContext.Provider>
  );
};